import React from "react";

export default function TransactionFilters({ activeFilter, setActiveFilter }) {
    const filters = ["All Transaction", "deposit", "withdraw", "exchange"];

    return (
        <div
            className="d-flex overflow-auto mb-4 pb-2 px-3"
            style={{ gap: "10px" }}
        >
            {filters.map((filter) => (
                <div
                    style={{
                        backgroundColor:
                            activeFilter === filter ? "#2E2CB2" : "#1E1E1E",
                        color: "#fff",
                        border: "none",
                        padding: 0,
                        height: "36px",
                        paddingLeft: "10px",
                        paddingRight: "10px",
                        fontSize: "13px",
                        fontWeight: "500",
                        minWidth: "130px",
                        cursor: "pointer",
                        textTransform: "capitalize",
                    }}
                    key={filter}
                    className={`rounded-pill text-white justify-content-center align-items-center d-flex`}
                    onClick={() => setActiveFilter(filter)}
                >
                    {filter}
                </div>
            ))}
        </div>
    );
}
